export const toImageSrc = (slug: string) =>
  `${(process.env.NEXT_PUBLIC_BASE_URL || '').replace(/\/+$/, '')}/storage/${(slug || '').replace(/^\/+/, '')}`
